// import { isNotNil } from '@bounty/utils'

/**
 * Cloudinary is caching the S3 resource making it to where brands only have one chance for the
 * right image.
 */
export const cloudinary =
  (_props: { width?: number; height?: number; mode?: 'c_fit' | 'c_fill' }) =>
  (s3Url: string) => {
    // const cloudinaryURL = `https://res.cloudinary.com/earn-bounty/image/fetch`
    // const defaults = 'f_auto,fl_progressive,q_auto:good,dpr_auto'
    // let additionalParams = ''
    // if (isNotNil(width)) additionalParams += `w_${width},`
    // if (isNotNil(height)) additionalParams += `h_${height},`
    // if (isNotNil(mode)) additionalParams += `${mode},`
    // if (additionalParams.endsWith(',')) {
    //   additionalParams = additionalParams.substring(
    //     0,
    //     additionalParams.length - 1,
    //   )
    // }

    return s3Url
    // return `${cloudinaryURL}/${defaults},${additionalParams}/${s3Url}`
  }
